module.exports = __webpack_public_path__ + "static/integration_737-892e178982f1204dabb29039bca60e9a.webp";